var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SortableTable',{attrs:{"loading":_vm.$fetchState.pending,"rows":_vm.events,"headers":_vm.eventHeaders,"key-field":"id","search":false,"table-actions":false,"row-actions":false,"paging":true,"rows-per-page":10,"default-sort-by":"date"}})
}
var staticRenderFns = []

export { render, staticRenderFns }